import { render, staticRenderFns } from "./SectionElement.vue?vue&type=template&id=138aedac&scoped=true&"
import script from "./SectionElement.vue?vue&type=script&lang=js&"
export * from "./SectionElement.vue?vue&type=script&lang=js&"
import style0 from "./SectionElement.vue?vue&type=style&index=0&id=138aedac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138aedac",
  null
  
)

export default component.exports